(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pack-builder"] && !Shopify.designMode) return;
  try {
    class PackBuilderComponent extends HTMLElement {
    connectedCallback() {
      this.tiersQty = (this.dataset.tiersQty || '').split(',').map((n) => parseInt(n, 10) || 0);
      this.tiersPct = (this.dataset.tiersPct || '').split(',').map((n) => parseInt(n, 10) || 0);
      this.items = Array.from(this.querySelectorAll('.pack-builder__item:not(.pack-builder__item--sold-out)'));
      this.pills = Array.from(this.querySelectorAll('.pack-builder__tier-pill'));
      this.fill = this.querySelector('.pack-builder__progress-fill');
      this.message = this.querySelector('.pack-builder__message');
      this.summary = this.querySelector('.pack-builder__summary');
      this.addButton = this.querySelector('.pack-builder__add');
      this.error = this.querySelector('.pack-builder__error');
      this.isPro = this.dataset.isPro === 'true';
      this.vatDivisor = 1 + (parseInt(this.dataset.vatPercent, 10) || 0) / 100;
      this.exVatLabel = this.dataset.exVatLabel || '';

      try {
        this.i18n = JSON.parse(this.querySelector('.pack-builder__i18n').textContent);
      } catch (e) {
        this.i18n = { next: '', unlocked: '', empty: '' };
      }

      this.money = new Intl.NumberFormat(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: this.dataset.currency || 'EUR',
      });

      // Pro customers see ex-VAT amounts everywhere the theme shows a price.
      this.formatCents = (cents) => {
        const amount = this.money.format((this.isPro ? cents / this.vatDivisor : cents) / 100);
        return this.isPro ? `${amount} ${this.exVatLabel}` : amount;
      };

      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      if (this.addButton) this.addButton.addEventListener('click', () => this.add());
    }

    onClick = (event) => {
      const step = event.target.closest('.pack-builder__step');
      if (!step) return;
      const input = step.parentElement.querySelector('.pack-builder__qty');
      const next = Math.min(99, Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.step, 10)));
      input.value = next;
      this.update();
    };

    onChange = (event) => {
      if (!event.target.classList.contains('pack-builder__qty')) return;
      event.target.value = Math.min(99, Math.max(0, parseInt(event.target.value, 10) || 0));
      this.update();
    };

    selection() {
      return this.items
        .map((item) => ({
          id: item.dataset.variantId,
          price: parseInt(item.dataset.price, 10) || 0,
          quantity: parseInt(item.querySelector('.pack-builder__qty').value, 10) || 0,
        }))
        .filter((item) => item.quantity > 0);
    }

    activeTierIndex(totalQty) {
      let active = -1;
      this.tiersQty.forEach((qty, i) => {
        if (totalQty >= qty) active = i;
      });
      return active;
    }

    update() {
      const selection = this.selection();
      const totalQty = selection.reduce((sum, item) => sum + item.quantity, 0);
      const totalCents = selection.reduce((sum, item) => sum + item.quantity * item.price, 0);
      const active = this.activeTierIndex(totalQty);
      const maxTier = this.tiersQty[this.tiersQty.length - 1] || 1;

      if (this.fill) {
        this.fill.style.width = `${Math.min(100, (totalQty / maxTier) * 100)}%`;
      }

      this.pills.forEach((pill, i) => {
        pill.classList.toggle('pack-builder__tier-pill--active', i === active);
      });

      if (this.message) {
        this.message.classList.remove('pack-builder__message--unlocked');
        if (totalQty === 0) {
          this.message.textContent = this.i18n.empty;
        } else if (active === this.tiersQty.length - 1) {
          this.message.textContent = this.i18n.unlocked.replace('[pct]', this.tiersPct[active]);
          this.message.classList.add('pack-builder__message--unlocked');
        } else {
          const nextIndex = active + 1;
          this.message.textContent = this.i18n.next
            .replace('[count]', this.tiersQty[nextIndex] - totalQty)
            .replace('[pct]', this.tiersPct[nextIndex]);
          if (active >= 0 && this.tiersPct[active] > 0) {
            this.message.classList.add('pack-builder__message--unlocked');
          }
        }
      }

      if (this.summary) {
        if (totalQty > 0) {
          const pct = active >= 0 ? this.tiersPct[active] : 0;
          if (pct > 0) {
            const discounted = Math.round((totalCents * (100 - pct)) / 100);
            this.summary.innerHTML = `<s>${this.formatCents(totalCents)}</s> ${this.formatCents(discounted)}`;
          } else {
            this.summary.textContent = this.formatCents(totalCents);
          }
          this.summary.hidden = false;
        } else {
          this.summary.hidden = true;
        }
      }

      if (this.addButton) this.addButton.disabled = totalQty === 0;
    }

    // Mirrors cart-upsell.js: items[] add + cart:update so the drawer re-renders/opens.
    async add() {
      const selection = this.selection();
      if (!selection.length || this.addButton.getAttribute('aria-disabled') === 'true') return;

      this.addButton.setAttribute('aria-disabled', 'true');
      if (this.error) this.error.hidden = true;

      const cartItems = document.querySelector('cart-items-component');
      const cartSectionId = cartItems instanceof HTMLElement ? cartItems.dataset.sectionId : null;

      const body = { items: selection.map(({ id, quantity }) => ({ id, quantity })) };
      if (cartSectionId) {
        body.sections = cartSectionId;
        body.sections_url = window.location.pathname;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        if (data.status) throw new Error(data.description || data.message);

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { source: 'pack-builder', data: { sections: data.sections } },
          })
        );

        this.items.forEach((item) => {
          item.querySelector('.pack-builder__qty').value = 0;
        });
        this.update();
      } catch (error) {
        console.error('Pack builder add error:', error);
        if (this.error) this.error.hidden = false;
      } finally {
        this.addButton.removeAttribute('aria-disabled');
      }
    }
  }

  if (!customElements.get('pack-builder-component')) {
    customElements.define('pack-builder-component', PackBuilderComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-ugc-video"] && !Shopify.designMode) return;
  try {
    class VideoEmbed extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[ref="trigger"]');
      if (this.trigger) {
        this.trigger.addEventListener('click', () => this.load(), { once: true });
      }
    }

    load() {
      const raw = this.dataset.url || '';
      let src = raw;
      const yt = raw.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]+)/);
      const vimeo = raw.match(/vimeo\.com\/(\d+)/);
      if (yt) src = `https://www.youtube.com/embed/${yt[1]}?autoplay=1`;
      else if (vimeo) src = `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1`;

      const iframe = document.createElement('iframe');
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.style.cssText = 'width:100%;aspect-ratio:16/9;border:0;border-radius:8px;';
      iframe.src = src;
      this.replaceChildren(iframe);
    }
  }

  if (!customElements.get('video-embed')) {
    customElements.define('video-embed', VideoEmbed);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    if (!window.__reviewScrollBound) {
    window.__reviewScrollBound = true;
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.rating-wrapper--link');
      if (!link) return;
      var target = null;
      var id = (link.getAttribute('href') || '').replace(/^#/, '');
      if (id) target = document.getElementById(id);
      if (!target) {
        target = document.querySelector('[id*="judge_me_reviews"], .jdgm-rev-widg, .jdgm-widget, #shopify-product-reviews, [id*="product_reviews"]');
      }
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      // The buy-box column uses .sticky-content--desktop (position:sticky + z-index), which
      // creates a stacking context that traps this position:fixed bar so later sections (e.g.
      // the comparison table) paint over it. Hoist the bar to <body> so it competes in the
      // root stacking context and overlays page content. appendChild re-fires connectedCallback
      // re-entrantly, so move-then-return and guard real setup with _init (no double add-to-cart).
      if (this.parentElement !== document.body) {
        document.querySelectorAll('sticky-buy-bar').forEach((el) => {
          if (el !== this && el.parentElement === document.body) el.remove();
        });
        document.body.appendChild(this);
        return;
      }
      if (this._init) return;
      this._init = true;

      this.addButton = this.querySelector('[ref="addButton"]');
      this.realButton = document.querySelector('product-form-component .add-to-cart-button')
        || document.querySelector('product-form-component button[name="add"]');
      this.buyBox = document.querySelector('product-form-component');

      if (this.addButton && this.realButton) {
        this.addButton.addEventListener('click', () => this.realButton.click());
      }

      if (this.buyBox && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          this.classList.toggle('is-visible', !entry.isIntersecting);
        }, { rootMargin: '0px 0px -10% 0px' });
        this.observer.observe(this.buyBox);
      } else {
        this.classList.add('is-visible');
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('sticky-buy-bar')) {
    customElements.define('sticky-buy-bar', StickyBuyBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__swatchColorFromImage) return;
    window.__swatchColorFromImage = true;

    var cache = new Map();

    function deriveColor(url) {
      if (cache.has(url)) return Promise.resolve(cache.get(url));
      return new Promise(function (resolve) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          try {
            var size = 24;
            var canvas = document.createElement('canvas');
            canvas.width = size;
            canvas.height = size;
            var ctx = canvas.getContext('2d', { willReadFrequently: true });
            ctx.drawImage(img, 0, 0, size, size);
            var px = ctx.getImageData(0, 0, size, size).data;
            var buckets = {};
            var center = (size - 1) / 2;
            var maxDist = Math.hypot(center, center);
            for (var y = 0; y < size; y++) {
              for (var x = 0; x < size; x++) {
                var i = (y * size + x) * 4;
                var r = px[i], g = px[i + 1], b = px[i + 2], a = px[i + 3];
                if (a < 200) continue;
                var max = Math.max(r, g, b), min = Math.min(r, g, b);
                var light = (max + min) / 2;
                var sat = max === min ? 0 : (max - min) / (255 - Math.abs(max + min - 255));
                // Skip near-white / near-black background and washed-out pixels.
                if (light > 238 && sat < 0.12) continue;
                if (light < 14) continue;
                var weight = 1 + 2 * (1 - Math.hypot(x - center, y - center) / maxDist);
                var key = (r >> 4) + '|' + (g >> 4) + '|' + (b >> 4);
                var bk = buckets[key] || (buckets[key] = { r: 0, g: 0, b: 0, n: 0 });
                bk.r += r * weight; bk.g += g * weight; bk.b += b * weight; bk.n += weight;
              }
            }
            var best = null;
            for (var k in buckets) { if (!best || buckets[k].n > best.n) best = buckets[k]; }
            var color = best
              ? 'rgb(' + Math.round(best.r / best.n) + ',' + Math.round(best.g / best.n) + ',' + Math.round(best.b / best.n) + ')'
              : null;
            cache.set(url, color);
            resolve(color);
          } catch (e) {
            cache.set(url, null);
            resolve(null);
          }
        };
        img.onerror = function () { cache.set(url, null); resolve(null); };
        img.src = url;
      });
    }

    function process(root) {
      (root || document)
        .querySelectorAll('.swatch[data-swatch-image]:not([data-swatch-derived])')
        .forEach(function (el) {
          el.setAttribute('data-swatch-derived', '');
          var url = el.getAttribute('data-swatch-image');
          if (!url) return;
          deriveColor(url).then(function (color) {
            if (color) el.style.setProperty('--swatch-background', color);
          });
        });
    }

    function init() {
      process(document);
      var observer = new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var added = mutations[m].addedNodes;
          for (var n = 0; n < added.length; n++) {
            if (added[n].nodeType === 1) process(added[n]);
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["volume-discount"] && !Shopify.designMode) return;
  try {
    class VolumeDiscountComponent extends HTMLElement {
    connectedCallback() {
      this.basePrice = parseInt(this.dataset.basePrice, 10) || 0;
      this.tiersQty = (this.dataset.tiersQty || '').split(',').map((n) => parseInt(n, 10) || 0);
      this.tiersPct = (this.dataset.tiersPct || '').split(',').map((n) => parseInt(n, 10) || 0);
      this.rows = Array.from(this.querySelectorAll('.volume-discount__row--tier'));
      this.live = this.querySelector('.volume-discount__live');
      this.isPro = this.dataset.isPro === 'true';
      this.vatDivisor = 1 + (parseInt(this.dataset.vatPercent, 10) || 0) / 100;

      try {
        this.i18n = JSON.parse(this.querySelector('.volume-discount__i18n').textContent);
      } catch (e) {
        this.i18n = { saving: '', none: '', exVat: '' };
      }

      this.money = new Intl.NumberFormat(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: this.dataset.currency || 'EUR',
      });

      // Pro customers see ex-VAT amounts everywhere; savings scale the same way.
      this.formatCents = (cents) => {
        const amount = this.money.format((this.isPro ? cents / this.vatDivisor : cents) / 100);
        return this.isPro ? `${amount} ${this.i18n.exVat}` : amount;
      };

      this.onQuantityUpdate = (event) => {
        // Ignore cart-drawer quantity selectors (they carry a cart line index).
        const line = event.detail && event.detail.cartLine;
        if (line !== undefined && !Number.isNaN(line)) return;
        this.update(event.detail.quantity);
      };
      document.addEventListener('quantity-selector:update', this.onQuantityUpdate);

      this.rows.forEach((row) => {
        row.addEventListener('click', () => this.setQuantity(parseInt(row.dataset.qty, 10) || 1));
      });

      this.update(this.currentQuantity());
    }

    disconnectedCallback() {
      document.removeEventListener('quantity-selector:update', this.onQuantityUpdate);
    }

    quantitySelector() {
      const section = this.closest('.shopify-section') || document;
      return section.querySelector('quantity-selector-component');
    }

    currentQuantity() {
      const selector = this.quantitySelector();
      if (!selector) return 1;
      const input = selector.querySelector('input');
      return parseInt(input && input.value, 10) || 1;
    }

    setQuantity(qty) {
      const selector = this.quantitySelector();
      if (!selector) return;
      if (typeof selector.setValue === 'function') {
        selector.setValue(qty);
        if (typeof selector.onQuantityChange === 'function') selector.onQuantityChange();
        if (typeof selector.updateButtonStates === 'function') selector.updateButtonStates();
      }
      this.update(qty);
    }

    activeTierIndex(qty) {
      let active = -1;
      this.tiersQty.forEach((tierQty, i) => {
        if (qty >= tierQty) active = i;
      });
      return active;
    }

    update(qty) {
      const active = this.activeTierIndex(qty);
      this.rows.forEach((row, i) => {
        row.classList.toggle('volume-discount__row--active', i === active);
        row.classList.remove('volume-discount__row--best');
      });

      if (!this.live) return;
      const pct = active >= 0 ? this.tiersPct[active] : 0;
      if (pct > 0) {
        const amount = this.formatCents((this.basePrice * pct * qty) / 100);
        this.live.textContent = this.i18n.saving
          .replace('[qty]', qty)
          .replace('[pct]', pct)
          .replace('[amount]', amount);
      } else {
        this.live.textContent = this.i18n.none;
      }
      this.live.hidden = false;
    }
  }

  if (!customElements.get('volume-discount-component')) {
    customElements.define('volume-discount-component', VolumeDiscountComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
